import {
	EnhancedDropDownRHFWithLabel,
	EnhancedMultiDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";

interface IScreenPermisionsInfoSetupFieldsPanel { screensDDLList: any, selectedDataRecord: any }
export const ScreenPermissionsInfoSetupFieldsPanel: FC<
	IScreenPermisionsInfoSetupFieldsPanel
> = ({ screensDDLList, selectedDataRecord }) => {

	const [permissionType, setPermissionType] = useState(true)
	const onPermissionTypeSelectionChangeHandler = (e: any) => {
		setPermissionType(e.value)
	}
	useEffect(() => {
		if (selectedDataRecord) {
			setPermissionType(selectedDataRecord.type === "switch" ? true : false)
		}
	}, [selectedDataRecord])
	return (
		<Box
		// sx={{
		// 	padding: "0",
		// 	"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
		// }}
		>
			<EnhancedMultiDropDownRHFWithLabel
				selectName="screenId"
				label="Screen"
				labelPosition={LabelPosition.Top}
				required
				testId={`screen-list`}
				items={screensDDLList ?? []}
			// onSelectionChangeHandler={onScreenSelectionChangeHandler}
			/>
			<RHookFormTextFieldWithLabel
				label="Name"
				id="name"
				testId={`name`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				label="Permission Type"
				selectName="permissionType"
				testId={`permission-type`}
				labelPosition={LabelPosition.Top}
				items={[{ label: "Yes/No", value: true }, { label: "Custom List", value: false }]}
				onSelectionChangeHandler={onPermissionTypeSelectionChangeHandler}
				selectedItem={true}
			/>
			{!permissionType &&
				<RHookFormTextFieldWithLabel
					label="Choice Values"
					id="values"
					testId={`choiceValues`}
					labelPosition={LabelPosition.Top}
				/>
			}
		</Box>
	);
};
